import ModalPortal from "../../Assets/ModalPortal/ModalPortal"
import { useState } from "react"
import LocalizedLink from "../../../hoc/LocalizedLink"
import SelectLang from "../../SelectLang/SelectLang"
import { useTranslation } from "react-i18next"
import { useAppSelector } from "../../../hooks"
import { selectParams } from "../../../redux/slice/params"
import {
  HAS_USER_OBJECT_COOKIE,
  LANGUAGES,
  MAX_AGE_TOKEN_180_DAYS_IN_SECONDS,
  USER_OBJECT_COOKIE,
} from "../../../utils/constants"
import styles from "./ObjectSelectionModal.module.scss"
import { selectProjects } from "../../../redux/slice/main"
import { ArrowRightIcon } from "../../../icons/ArrowRightIcon"
import { GetUserAvatar } from "../../Assets/GetUserAvatar/GetUserAvatar"
import useWindowSize from "../../../hooks/useWindowSize"
import { setCookie } from "../../../utils/cookies"
import { useSetMainUserProjectMutation } from "../../../redux/api/auth"
import BtnLoader from "../../Assets/BtnLoader/BtnLoader"
import clsx from "clsx"

const ObjectSelectionModal = ({ setOpenObjectsModal }: { setOpenObjectsModal: any }) => {
  const { t } = useTranslation("translation", { keyPrefix: `interface` })
  const { companyLogo } = useAppSelector(selectParams)
  const { size } = useWindowSize()
  const [setUserProject] = useSetMainUserProjectMutation()
  const projects = useAppSelector(selectProjects)
  const [isLoading, setIsLoading] = useState<string>("")
  const [isOpen, setOpen] = useState<boolean>(true)

  const setUserCookie = (user: any) => {
    setCookie(USER_OBJECT_COOKIE, JSON.stringify(user), {
      maxAge: MAX_AGE_TOKEN_180_DAYS_IN_SECONDS,
      sameSite: "lax",
      path: process.env.NEXT_PUBLIC_ASSET_PREFIX || "/",
      expires: new Date(user.accessTokenExpires * 1000),
    })
  }

  const setProject = (projectId: string) => {
    if (isLoading) return
    setIsLoading(projectId)

    setUserProject(projectId)
      .unwrap()
      .then((res) => {
        setUserCookie(res.data)

        setCookie(HAS_USER_OBJECT_COOKIE, "true", {
          maxAge: 2147483647, //68 лет
          sameSite: "lax",
          path: process.env.NEXT_PUBLIC_ASSET_PREFIX || "/",
          expires: new Date("Fri, 31 Dec 9999 23:59 GMT"),
        })

        setOpenObjectsModal("true")
      })
  }

  return (
    <ModalPortal className={styles.modal} isOpen={isOpen} setIsOpen={setOpen}>
      {companyLogo.data && (
        <div className={styles.header}>
          <LocalizedLink to={"/"} className={styles.logo}>
            {companyLogo.type === "image/svg+xml" ? (
              <span dangerouslySetInnerHTML={{ __html: companyLogo.data }} />
            ) : (
              <img src={companyLogo.data} alt={"logo"} />
            )}
          </LocalizedLink>
          {LANGUAGES?.length > 0 && <SelectLang className={styles.lang} />}
        </div>
      )}
      <p className={styles.logoTxt}>
        powered by {process.env.REACT_APP_PUBLIC_PROJECT_TYPE === "digitask" ? "Digitask" : "Staq"}
      </p>
      <div className={styles["projects-container"]}>
        <div className={styles["projects-container__header"]}>
          <div className={styles["projects-container__title"]}>{t("selectProject")}</div>
          <div className={styles["projects-container__subtitle"]}>{t("selectProjectSubtitle")}</div>
        </div>
        <div className={styles["projects"]}>
          {!projects || projects.length === 0 ? (
            <div className={clsx(styles["loader-container"])}>
              {[...Array(3)].map((_item, index) => (
                <div key={index} className={clsx("skeletonBlock", styles.skeletonBlock)} />
              ))}
            </div>
          ) : (
            <>
              {projects.map((el: any) => (
                <div key={el.id} className={styles["project-item"]} onClick={() => setProject(el.id)}>
                  <div className={styles["project-item__avatar"]}>
                    <GetUserAvatar
                      name={el.name}
                      avatar={el.avatar_id}
                      size={size[0] > 575 ? "smd" : undefined}
                      className={styles.current__icon}
                    />
                  </div>
                  <div className={styles["project-item__content"]}>
                    <div className={styles["project-item__title"]}>{el.name}</div>
                    <div className={styles["project-item__descr"]}>{el.description}</div>
                  </div>
                  {isLoading === el.id ? (
                    <div className={styles["project-item__loader"]}>
                      <BtnLoader />
                    </div>
                  ) : (
                    <div className={styles["project-item__arrow"]}>
                      <ArrowRightIcon />
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </ModalPortal>
  )
}

export default ObjectSelectionModal
